import {getHostByCp} from '@/utils'
const app = {
	namespaced: true,
	state: {
		windowHeight: 800,
		redirect_url: '',
		siteCpList: [
			{
				cpId: '1',
				name: '磨铁中文网'
			}, {
				cpId: '5',
				name: '锦文小说网'
			}, {
				cpId: '2',
				name: '墨墨言情网'
			}, {
				cpId: '4',
				name: '逸云书院'
			}, {
				cpId: '6',
				name: '醉唐中文网'
			},
			// {
			// 	cpId: '8',
			// 	name: '蓝海阅读'
			// }
		],
		registerEmail: undefined,
		headerSiteName: '',
		site: '',
		host: location.host,
		tokenKey: 'x-access-token-a',
		beforeClose: function () {},
		pcSiteHost: ''
	},
	getters: {
		redirect_url: (state) => {
			if (state.redirect_url) {
				return state.redirect_url
			} else {
				return location.href
			}
		}
	},
	mutations: {
		setRegisterEmail(state, email) {
			state.registerEmail = email
		},
		setRedirectUrl(state, url) {
			state.redirect_url = url
		},
		setSite(state, cpId) {
			let site = ''
			let tempSiteName = ''
			if (cpId === 1 || cpId === 8) {
				site = 'motie'
				tempSiteName = '磨铁'
			} else if (cpId === 2) {
				site = 'mm'
				tempSiteName = '墨墨'
			} else if (cpId === 4) {
				site = 'yynovel'
				tempSiteName = '逸云'
			} else if (cpId === 5) {
				site = 'jw'
				tempSiteName = '锦文'
			} else if (cpId === 6) {
				site = 'zuitang'
				tempSiteName = '醉唐'
			}
			state.pcSiteHost = getHostByCp(cpId)
			state.headerSiteName = tempSiteName
			state.site = site
		}

	},
	actions: {
		setVolumesMutation: ({state}, height) => {
			if (height < 600) {
				height = 600
			}
			state.windowHeight = height
		}

	}

}
export default app



// WEBPACK FOOTER //
// ./src/store/app.js